export const COMPANIES_TRANSLATIONS = {
  Medtronic: 'Medtronic',
  Abbott: 'Abbott',
  'Boston Scientific': 'Boston',
  Biotronik: 'Biotronik',
  Sorin: 'Sorin',
}

// Maps the manufacturer values stored on transmissions/alerts (snake_case)
// back to the display labels the rest of the app uses, falling back to a
// humanized value.
const MANUFACTURER_LABELS = Object.fromEntries(
  Object.entries(COMPANIES_TRANSLATIONS).map(([key, label]) => [
    key.toLowerCase().replace(/\s+/g, '_'),
    label,
  ]),
)

export function manufacturerLabel(value) {
  if (!value) return ''
  return (
    MANUFACTURER_LABELS[value] ||
    value
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  )
}
